import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "field p-3" }
const _hoisted_2 = { class: "p-float-label" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, "New Password*", -1)
const _hoisted_4 = {
  key: 0,
  class: "p-error"
}
const _hoisted_5 = { class: "field p-3" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "passwordMatch" }, "Confirm Password*", -1)
const _hoisted_8 = {
  key: 0,
  class: "p-error"
}

import { ref, computed } from 'vue';
import Password from 'primevue/password';


export default /*#__PURE__*/_defineComponent({
  emits: ["submit"],
  setup(__props, { expose, emit }: { emit: ({ (e: 'submit', payload: { password: string }): void }), expose: any, slots: any, attrs: any }) {



const password = ref('');
const passwordMatch = ref('');
const submitted = ref(false);

const passwordError = computed(() => (submitted.value && !password.value) ? 'Password is required' : '');
const passwordMatchError = computed(() => {
  if (!submitted.value) return '';
  if (!passwordMatch.value) return 'Confirm password is required';
  if (passwordMatch.value !== password.value) return 'Passwords do not match';
  return '';
});

const submit = () => {
  submitted.value = true;
  if (passwordError.value || passwordMatchError.value) return false;
  emit('submit', { password: password.value });
  return true;
};

expose({ submit });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_unref(Password), {
          modelValue: password.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
          id: "password",
          toggleMask: "",
          feedback: false,
          class: _normalizeClass({ 'p-invalid': !!_unref(passwordError) })
        }, null, 8, ["modelValue", "class"]),
        _hoisted_3
      ]),
      (_unref(passwordError))
        ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_unref(passwordError)), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, [
        _createVNode(_unref(Password), {
          modelValue: passwordMatch.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((passwordMatch).value = $event)),
          id: "passwordMatch",
          toggleMask: "",
          feedback: false,
          class: _normalizeClass({ 'p-invalid': !!_unref(passwordMatchError) })
        }, null, 8, ["modelValue", "class"]),
        _hoisted_7
      ]),
      (_unref(passwordMatchError))
        ? (_openBlock(), _createElementBlock("small", _hoisted_8, _toDisplayString(_unref(passwordMatchError)), 1))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})